var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "app-main", class: { "main-border": _vm.mainBorder } },
    [
      _c("router-view", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ Component, route }) {
              return [
                _c(
                  "transition",
                  { attrs: { name: "fade-transform", mode: "out-in" } },
                  [
                    _c(
                      "keep-alive",
                      { attrs: { include: _vm.cachedViews } },
                      [
                        !route.meta.link
                          ? _c(Component, { key: route.path, tag: "component" })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }